/* ⚛ REACT */
import { useEffect, useRef, useState } from "react";

/* 📦 LIBS */
import { toast } from "react-toastify";
import { useNavigate,useParams } from "react-router";
import { useTranslation } from "react-i18next";

/* 🧩 COMPONENTS */
import { InputSelect, Input, InputCheckbox, Label, Button, CustomLoading, SaveIcon } from "../../../../Components";

/* 🔗 SERVICE */
import { PartsComandServices } from "../../../../Services/partscommandService";

/* 📁 ASSETS*/
import { Excluir } from "../../../../Assets/icons";

/* 🎨 STYLES */
import { Container, TitleContainer, Title, ContainerRow, ContainerColumn, ImageIcon, ButtonsContainer } from "./styles";

/* 🔧 UTILS */
import { isValidField } from "../../../../util/validate";

const ViewGroupVariables = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    document.title = "Edição de ligação de part Command - variável";
    const [loading, setLoading] = useState(true);
    const [parts, setParts] = useState([]);

    let { id } = useParams();
    const Services = useRef(new PartsComandServices());

    const partCommandField = useRef();
    const nameField = useRef();

    const partCommandValue = useRef();
    const nameValue = useRef();
    const isBombValue = useRef(false);

    const [partCommand, setPartCommand] = useState();

    useEffect(() => {
        async function getGroupVariable(){
            setLoading(true)
            let currentItem = await Services.current.getGroupVariable(id);
            if(currentItem){
                setPartCommand(currentItem);
            }
            setLoading(false)
        }

        async function getParts(){
            let currentItem = await Services.current.getAllPartCommands();
            setParts(currentItem);
        }


        getGroupVariable();
        getParts();
    }, [id]);

    // method-spoofing
    // Salva as edições
    async function Save(){
        if(isValidField(partCommandValue.current)){
            let form = new FormData();
            if(partCommandValue.current){form.append('part_command_id', partCommandValue.current)}
            if(nameValue.current){form.append('name', nameValue.current)}
            form.append('isBomb', isBombValue.current ? 1 : 0)

            form.append('_method', 'PATCH')

            let currentitem = await Services.current.editGroupVariable(id, form)
            if(currentitem){
                setPartCommand(currentitem);
            }
        }else{
            toast(t("message.save"), {
                position: "top-center",
                type: 'info',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
            });
        }
    }

    return (
        <>  
            <Container>
                <TitleContainer>
                    <Title>Grupo de variáveis</Title>
                </TitleContainer>

                {loading ? <CustomLoading width={'150px'} height={'150px'}/>:
                <>
                    <ContainerRow onSubmit={(e)=> e.preventDefault()}>
                        <ContainerColumn>
                            <Label text={"part Command"} aling="flex-start"/>
                            <InputSelect
                                key={'part_command'}
                                name={'part_command'}
                                id={'part_command'}
                                placeholder={"Part Command"}
                                invalidMessage = {"Part Command inválido!"}
                                options={parts}
                                innerRef={partCommandField}
                                value={partCommand?.part_command_id}
                                validationFunction = {(value) => isValidField(value)}
                                onchange={(value) => partCommandValue.current = value}>
                            </InputSelect>                      
                        </ContainerColumn>

                        <ContainerColumn>
                            <Label text={"Nome"} aling="flex-start"/>
                            <Input
                                key={'name'}
                                name={'name'}
                                id={'name'}
                                placeholder={"Nome"}
                                invalidMessage = {"Nome inválida!"}
                                innerRef={nameField}
                                value={partCommand?.name}
                                validationFunction = {(value) => isValidField(value)}
                                onchange={(value) => nameValue.current = value}>
                            </Input>

                            <InputCheckbox text={t("inputs.isBomb.label")} checked={partCommand?.isBomb} onChange={(value)=> {isBombValue.current = value; return true}}/>
                        </ContainerColumn>
                    </ContainerRow>

                    <ButtonsContainer>
                        <Button text={t("buttons.save")} width={'150px'} icon={<SaveIcon/>} onClick={()=>Save()}/>
                        <Button text={t("buttons.delete")} width={'150px'} color={'white-red'} onClick={async function(){
                            await Services.current.deleteGroupVariable(id);
                            navigate('/EncapsuledVariablesGroups')
                        }} icon={<ImageIcon src={Excluir}/>}/>
                    </ButtonsContainer>
                </>}

            </Container>
        </>
    );
}

export default ViewGroupVariables;